<template>
  <div
    class="icu-modal-wrapper"
    @click.self="$emit('close')"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'PcModalWrapper'
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/components/modals/PcModalWrapper.scss";
</style>
